wbApp.directive('wbShareOnFacebook', ['facebookSvc', 'tenantInfo',
    function (facebookSvc, tenantInfo) {
        return {
            restrict: 'EA',
            priority: 1,
            scope: {
                course: '=',
                action: '='
            },
            replace: true,
            template:
                "<div style='display: inline-block; position: relative; margin-left: 20px' >" +
                    "<div style='position: absolute; top: 0; bottom:0; left: 0; right: 0; background-color: transparent; z-index: 1000;'" +
                          "ng-click='onFBButtonClick()'></div>" +
                    "<div style='position: relative; top: -5px'" +
                         "class='fb-share-button'" +
                         "data-href='" + "{{course.courseID}}" + "'" +
                         "data-layout='button_count'></div>"+
                 "</div>",
            controller: ['$scope', function ($scope) {
                var alias = tenantInfo.alias;
                var courses = "";

                if ($scope.action) {
                    courses = 'Actions';
                    $scope.courseHref = "https://" + alias + tenantInfo.domain + "/" + courses + "/Register/" + $scope.action.courseID;
                } else {
                    courses = 'Courses';
                    $scope.courseHref = "https://" + alias + tenantInfo.domain + "/" + courses + "/Register/" + $scope.course.courseID;
                }

                $scope.onFBButtonClick = function () {

                    if ($scope.action) {
                        facebookSvc.shareCourseDetail(
                            $scope.action.courseID,
                            $scope.action.subjectName,
                            $scope.action.name,
                            $scope.action.subjectDescription,
                            $scope.action.description,
                            $scope.action.teacher,
                            (!!$scope.action.pictures && !!$scope.action.pictures.length)
                                ? $scope.action.pictures[0].imageUrl
                                : null,
                            true
                            );
                    } else {
                        facebookSvc.shareCourseDetail(
                            $scope.course.courseID,
                            $scope.course.subjectName,
                            $scope.course.name,
                            $scope.course.subjectDescription,
                            $scope.course.description,
                            $scope.course.teacher,
                            (!!$scope.course.pictures && !!$scope.course.pictures.length)
                                ? $scope.course.pictures[0].imageUrl
                                : null,
                            false
                            );
                    }
                }
            }]
        }
}]);